var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"id":"bid-summary","data-cy":"bid-summary","fluid":"","tag":"section"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('idc-component-bid-summary',{attrs:{"type":_vm.status,"statuses":_vm.bidStatuses,"can-submit-bid":_vm.canSubmitBid}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }